module.exports = __webpack_public_path__ + "static/img/019_TO8_1481_og.e4b969f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/019_TO8_1481_og.jpg
// module id = Kotf
// module chunks = 0